import React from 'react';
import LayoutWrapper from './layout/LayoutWrapper';
import { Routes, Route, useNavigate } from 'react-router-dom';
import NotFound from './pages/common/404';
import { CONFIG } from './utils/config';
import Login from './pages/common/login';
import RoleBasedRoute from './utils/RoleBasedRoute';
import Logout from './pages/common/logout';
import Dashboard from './pages/admin/dashboard';
import OntotitesDashboard from './pages/admin/ontotites/ontotitesDashboard';
import OntotitaAdd from './pages/admin/ontotites/ontotitaAdd';
import OntotitaEdit from './pages/admin/ontotites/ontotitaEdit';
import PersonDashBoard from './pages/admin/person/personsDashboard';
import PersonAdd from './pages/admin/person/personAdd';
import PersonEdit from './pages/admin/person/personEdit';
import UserAdd from './pages/admin/users/userAdd';
import UserEdit from './pages/admin/users/userEdit';
import UserDashBoard from './pages/admin/users/usersDashboard';
import OntotitaView from './pages/admin/ontotites/ontotitaView';
import UserView from './pages/admin/users/userView';
import ResetPassword from './pages/common/reset-password';
import ResetPasswordCompleted from './pages/common/reset-password-completed';
import ResetPasswordThankYou from './pages/common/reset-password-thankyou';
import { useAuth } from './utils/authContext';
import ProfileUser from './pages/admin/profile/profileUser';
import ProfileUserEdit from './pages/admin/profile/profileUserEdit';
import GeneralErrorPage from './pages/common/general-error';


function App() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();  // Use context to get auth status

  // Prevent redirection for reset password pages when already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      // If already logged in, navigate away from login or reset password page
      const currentPath = window.location.pathname;
      if (currentPath === CONFIG.urls.getResetPasswordUrl() || 
          currentPath === CONFIG.urls.getLoginUrl()) {
        navigate(CONFIG.urls.getDashboardUrl_Admin()); // Redirect to the dashboard
      }
    }
  }, [isAuthenticated, navigate]);
  return (
    <LayoutWrapper activeSection={''}>
      
      <Routes>
        {/* These routes are accessible to all users, no authentication required */}
        <Route path="*" element={<NotFound />} />
        <Route path="*" element={<GeneralErrorPage />} />
        <Route path={CONFIG.urls.getLoginUrl()} element={<Login />} />
        <Route path={CONFIG.urls.getResetPasswordUrl()} element={<ResetPassword />} />
        <Route path={CONFIG.urls.getResetPasswordCompletedUrl()} element={<ResetPasswordCompleted />} />
        <Route path={CONFIG.urls.getResetPasswordThankYouUrl()} element={<ResetPasswordThankYou />} />

        {/* The Logout route */}
        <Route path={CONFIG.urls.getLogoutUrl()} element={<Logout />} />
        <Route 
          path={CONFIG.urls.getLogoutUrl()} 
          element={
              <Logout />
          } 
        />
        <Route 
          path={CONFIG.urls.getDashboardUrl_Admin()} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <Dashboard />
              </RoleBasedRoute>
        
          } 
        />
        {/* ONTOTITA ROUTES */}
        <Route 
          path={CONFIG.urls.getOntotitaUrl_Admin()} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <OntotitesDashboard />
           </RoleBasedRoute>
          } 
        />

        <Route 
          path={CONFIG.urls.getOntotitaAddUrl_Admin()} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <OntotitaAdd />
           </RoleBasedRoute>
          } 
        />

        <Route 
          path={CONFIG.urls.getOntotitaEditUrl_Admin(':id')} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <OntotitaEdit />
           </RoleBasedRoute>
          } 
        />
       {/* Catch-all route for 404 */}
        <Route 
          path="ontotita/view/*"
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <OntotitaView />
           </RoleBasedRoute>
          } 
        />

          

          <Route 
          path={CONFIG.urls.getPersonsUrl_Admin()} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <PersonDashBoard />
           </RoleBasedRoute>
          } 
        />

        <Route 
          path={CONFIG.urls.getPersonsAddUrl_Admin()} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <PersonAdd />
           </RoleBasedRoute>
          } 
        />

        <Route 
          path={CONFIG.urls.getPersonsEditUrl_Admin(':id')} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <PersonEdit />
           </RoleBasedRoute>
          } 
        />
    {/* Users ROUTES */}
    <Route 
          path={CONFIG.urls.getUsersUrl_Admin()} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <UserDashBoard />
           </RoleBasedRoute>
          } 
        />

        <Route 
          path={CONFIG.urls.getUsersAddUrl_Admin()} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <UserAdd />
           </RoleBasedRoute>
          } 
        />

        <Route 
          path={CONFIG.urls.getUsersEditUrl_Admin(':id')} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <UserEdit />
           </RoleBasedRoute>
          } 
        />
    <Route 
          path={CONFIG.urls.getUsersViewUrl_Admin(':id')} 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <UserView />
           </RoleBasedRoute>
          } 
        />
        <Route 
          path={CONFIG.urls.getProfileUrl() } 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <ProfileUser />
           </RoleBasedRoute>
          } 
        />
   
        <Route 
          path={CONFIG.urls.getProfileEditUrl() } 
          element={
            <RoleBasedRoute allowedRoles={['admin', 'unitadmin']}>
              <ProfileUserEdit />
           </RoleBasedRoute>
          } 
        />
  
      </Routes>

      
    </LayoutWrapper>
  );
}

export default App;
